<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import axios from 'axios';
import moment from "moment";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Profit Analysis",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect,
  },
  data() {
    return {
      total_bprice: 0,
      total_sprice: 0,
      total_discount: 0,
      filterSales:{
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        product: '',
        category: '',
        title: 'Profit Analysis from '+this.datefrom+' to '+this.dateto,
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Profit Analysis Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Profit Analysis Report",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "sale.sale_date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "product",
          sortable: true,
          label: 'PRODUCT',
        },
        {
          key: "qty",
          sortable: true,
          label: 'QUANTITY',
        },
        {
          key: "SPrice_no",
          sortable: true,
          label: 'UNIT SELLING PRICE',
        },
        {
          key: "total_price",
          sortable: true,
          label: 'TOTAL SELLING PRICE',
        },
        {
          key: "BPrice_no",
          sortable: true,
          label: 'UNIT BUYING PRICE',
        },
        {
          key: "total_bprice",
          sortable: true,
          label: 'TOTAL BUYING PRICE',
        },
        {
          key: "profit",
          sortable: true,
          label: 'PROFIT',
        },
      ],
    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("saledetails", ["SaveStatus","SalesReport","filterStatus"]),
    ...mapGetters("products", ["Products","Categories"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.SalesReport ? this.SalesReport.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.SalesReport ? this.SalesReport.length : 1;
  },  
  methods: {
    ...mapActions({
      FetchSalesReport: "saledetails/fetchSalesReport",
      FetchProducts: "products/fetchProducts",
      FetchCategories: "products/fetchPCategories",

    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    SalesReportData() {
      this.FetchSalesReport(this.filterSales);
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    addCommas() {
        this.editAmtData.paid = this.thousandSeperator(this.editAmtData.paid);
    },
    Excel_export() {
      axios
        .post("export_profits", this.filterSales,{
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "profits_report.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.spinner = false;
        })
        .catch(() => {
        });
    },
  },
  updated() {
    let total_bprice = 0;
      let total_sprice = 0;
      let total_discount = 0;
      if(this.SalesReport){
        this.SalesReport.forEach((item)=>{
          total_bprice = total_bprice+parseInt(item.total_bprice.replaceAll(/\D/g, ""));
          total_sprice = total_sprice+parseInt(item.total_price.replaceAll(/\D/g, ""));
          total_discount = total_discount+parseInt(item.discount);
        });
        this.total_bprice = total_bprice;
        this.total_sprice = total_sprice;
        this.total_discount = total_discount;
      }
  },
  watch: {
    SalesReport(newValue){
      if(newValue == true){
        this.SalesReportData();
      }
    }
  },
  created() {
    this.FetchSalesReport(this.filterSales);
    this.FetchProducts();
    this.SalesReportData();
    this.FetchCategories();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center">Profit analysis from {{filterSales.datefrom}} to {{filterSales.dateto}}</h3>
              </div>

            </div>
            <div class="row mb-2">
              <div class="col-md-3 form-group">
                <label>CATEGORIES</label>
                
                <model-list-select
                  :list="Categories ? Categories : []"
                  v-model="filterSales.category"
                  option-value="id"
                  option-text="catName"
                  placeholder="Select Category"
                  @input="SalesReportData()"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <b-button variant="info" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button
                >
              </div>
              <div class="col-md-2 form-group mb-2">
                <label>FROM</label>
                <input
                  @change="SalesReportData()"
                  type="date"
                  v-model="filterSales.datefrom"
                  class="form-control"
                />
              </div>
              <div class="col-md-2 form-group">
                <label>TO</label>
                <input
                  @change="SalesReportData()"
                  v-model="filterSales.dateto"
                  type="date"
                  class="form-control"
                />
              </div>
              <div class="col-md-3 form-group">
                <label>PRODUCT</label>
                
                <model-list-select
                  :list="Products ? Products : []"
                  v-model="filterSales.product"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Product"
                  @input="SalesReportData()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="SalesReportData()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="SalesReport?SalesReport:[]"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(profit)="data">
                  {{ (data.item.profit).toLocaleString() }}
                </template>             
              </b-table>
              <div class="row">
                  <div class="col-md-3">
                    <h5>Total Buying Price: <span class="text-danger">{{(total_bprice).toLocaleString()}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Selling Price: <span class="text-danger">{{(total_sprice).toLocaleString()}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Discount: <span class="text-danger">{{(total_discount).toLocaleString()}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Profit: <span class="text-danger">{{(total_sprice-(total_bprice+total_discount)).toLocaleString()}}</span></h5>
                  </div>
                </div>
            </div>
            <Loader  v-if="!SalesReport"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
